export default __webpack_public_path__ + "static/media/bounty-header.3c7e5234.png";